export const USER_FAVOURITE_TYPE_NEWS = 'news'
export const USER_FAVOURITE_TYPE_BAS_BLOEM_PODCAST = 'bas_bloem_podcast'
export const USER_FAVOURITE_TYPE_WEBINAR = 'webinar'
export const USER_FAVOURITE_TYPE_MICHAEL_OKUN_INSTAGRAM = 'michael_okun_instagram'

export const USER_FAVOURITE_TYPES = [
  USER_FAVOURITE_TYPE_NEWS,
  USER_FAVOURITE_TYPE_BAS_BLOEM_PODCAST,
  USER_FAVOURITE_TYPE_WEBINAR,
  USER_FAVOURITE_TYPE_MICHAEL_OKUN_INSTAGRAM,
] as const

export type UserFavouriteType = (typeof USER_FAVOURITE_TYPES)[number]

export interface UserFavourite {
  uid: string
  userId: string
  createdTime?: Date
  type: string
  itemId: string
}
